<template>
  <div class="">
    <div class="pattern-title">
      <qualified-pattern :pattern="pattern" :core-indexes='coreIndexes'/>
    </div>
    <!-- semantic groups -->
    <collocation-list v-for="g in semanticGroups" :key="g.id"
      :lempos-list="g.collocations" :core-indexes="coreIndexes" :pattern="pattern" :title="g.name"/>
    <!-- Correct collocations that are not classified yet -->
    <collocation-list v-if="correctUngroupedColls.length > 0"
      :lempos-list="correctUngroupedColls" :core-indexes="coreIndexes" :pattern="pattern"
      title="متواردات غير مصنفة"/>
    <!-- Most frequent unrated collocations -->
    <collocation-list v-if="displayMostFrequent" :lempos-list="mostFrequentColls" :core-indexes="coreIndexes" :pattern="pattern"
      title="الأكثر ترددا (لم يتم تقييمها بعد)" class="candidates"/>
    <!-- On small devices, the review and the grouping view cannot be used -->
    <div class="links d-none d-lg-block">
      <router-link :to="'/review/' + lempos + '/' + makeQualifiedPattern(pattern, coreIndexes)">
        تقييم متواردات إضافية
      </router-link>
      &bullet;
      <router-link :to="'/group/' + lempos + '/' + makeQualifiedPattern(pattern, coreIndexes)">
        تصنيف المتواردات
      </router-link>
    </div>
  </div>
</template>

<script>
import CollocationList from './CollocationList.vue'
import QualifiedPattern from './QualifiedPattern.vue'
import { api } from '../mixins/api.js'

export default {
  name: 'PatternGroup',
  components: {
    CollocationList,
    QualifiedPattern
  },
  mixins: [api],
  props: {
    lempos: String,
    pattern: String,
    coreIndexes: Array
  },
  computed: {
    groups: function () {
      return this.$store.getters.getGroupsForQualifiedPattern(this.lempos, this.pattern, this.coreIndexes)
    },
    semanticGroups: function () {
      if (!this.groups) {
        return []
      }
      return this.groups.semantic_groups.filter(g => g.visible && g.collocations.length > 0)
    },
    correctUngroupedColls: function () {
      return this.groups ? this.groups.correct_ungrouped : []
    },
    mostFrequentColls: function () {
      return this.groups ? this.groups.unrated_by_freq.slice(0, this.$store.state.topnMinSize) : []
    },
    displayMostFrequent: function () {
      return true // this.correctUngroupedColls.length === 0 && this.semanticGroups.length === 0
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .candidates >>> .collocation {
    background-color: #E0E0E0 !important;
  }
</style>
